module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindentta"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "id": "dedica1"
    }
  }), _vm._v("Beyond all agony and anxiety lies the most important ingredient of self-reflection: the preciousness of my own existence. To my own heart my existence is unique, unprecedented, priceless, exceedingly precious, and I resist the thought of gambling away its meaning.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BRAHAM")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESCHEL,")]), _c('br'), _c('em', [_vm._v("Who Is Man?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentta"
  }, [_vm._v("The native calls the baobab “the devil tree” because he claims that the devil once got tangled in its branches and punished the tree by reversing it. To the native, the roots are branches now, and the branches are roots. To ensure that there would be no more baobabs, the devil destroyed all the young ones. And that’s why, the native says, there are only full-grown baobab trees left.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERZY")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSINSKI,")]), _c('br'), _c('em', [_vm._v("The Devil Tree")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b0e3b1f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedica1.vue
// module id = 84
// module chunks = 0